// Constants

export const info_liquidacion = () => {
    return {
        info_liquidacion: {
            id: {
                namepath: ["afiliado_liquidacion"],
                description: 'id autoincrement',
                label: 'Id',
                name: 'solId',
                readonly: true,
                type: 'number',
                datatype: {
                    predeterminate: null
                }
            },
            id_list_documento: {
                namepath: ["afiliado_liquidacion"],
                type: 'text',
                label: 'Tipo',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_documento",
                    label: 'name'
                },
            },
            id_datos_afiliado: {
                namepath: ["afiliado_liquidacion"],
                type: 'text',
                label: 'Afiliado',
                placeholder: '',
                description: 'Afiliado',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_afiliado",
                    label: 'name'
                },
            },
            id_datos_razon: {
                namepath: ["afiliado_liquidacion"],
                type: 'text',
                label: 'Razón social',
                placeholder: '',
                description: 'Nombre de la razón',
                validate: 'required',
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "datos_razon",
                    label: 'name'
                },
            },
            name: {
                type: "text",
                label: "Nombres",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            documento: {
                type: "number",
                label: "N° Documento",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "required",
                datatype: {
                    type: "price",
                    disabled: false,
                    prepend: '',
                    append: '',
                    predeterminate: '',
                }
            },
            fecha: {
                type: "date",
                label: "Fecha",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: true,
                    predeterminate: null,
                }
            },
            fechaini: {
                type: "date",
                label: "Fecha Inicial Liquidación",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            fechafin: {
                type: "date",
                label: "Fecha final Liquidación",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "required",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            cargo: {
                type: "text",
                label: "Cargosss",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null,
                }
            },
            salario: {
                type: "number",
                label: "Salario",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: false,
                    predeterminate: 0,
                    prepend: "$"
                }
            },
            valor: {
                type: "number",
                label: "Total",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "price",
                    disabled: true,
                    predeterminate: 0,
                    prepend: "$"
                }
            },
            transporte: {
                type: "number",
                label: "Auxilio transporte",
                placeholder: "",
                namepath: ["afiliado_liquidacion"],
                description: "",
                validate: "",
                datatype: {
                    type: "radio",
                    disabled: false,
                    predeterminate: 0,
                    options: [{ text: 'Sí', value: 102854 }, { text: 'No', value: 0 }]
                }
            },
        }
    }
}